import React, { useState, useEffect } from "react";
import { useAuth } from "react-oidc-context";
import styles from "../POIList/POIList.module.css";
import {
    DefaultButton,
    PrimaryButton,
    IStackTokens,
    Stack,
    StackItem,
    TextField,
    Dialog,
    DialogType,
    DialogFooter,
} from "@fluentui/react";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import strings from "../../../loc/strings";
import { DeleteAssessmentById } from "../../../services/ManageSystemServices/POIService";
import { AssessmentItem } from "../../../model/ManagePOIListItem";

initializeIcons();

const stackTokens: IStackTokens = { childrenGap: 20 };

function DeleteDialog(props: any) {
    const auth = useAuth();

    const handleSubmit = (event: any) => {
        event.preventDefault();
    }

    const handleDialogCloseDelete = () => {
        props.setDialogIsHiddenDelete(true);
    };

    const handleDialogDelete = (id: number) => {
        // Call the delete function (deleteEUSLB) with the provided id
        DeleteAssessmentById(props.encryptedId, auth.user?.id_token)
            .then((response) => {
                // Successful deletion, handle the response accordingly, e.g., update the user interface
                console.log('Assessment item deleted successfully:', response);
                props.handleActionResponse('assessdeletetrue');

                // Update the user interface, refresh the data list, etc.
            })
            .catch((error) => {
                // If there is an error during deletion, handle it, e.g., display an error message
                console.error('Error deleting Assessment item:', error);
                props.handleActionResponse('assessdeletefalse');
            });
        handleDialogCloseDelete();
    };

    // Dialog Edit Assessment
    const dialogContentPropsEdit = {
        type: DialogType.normal,
        title: props.title,
    };

    const modalPropsEdit = React.useMemo(
        () => ({
            isBlocking: true,
        }),
        [],
    );

    return (
        <div className="AssessmentDelete">
            <Dialog
                hidden={props.dialogIsHiddenDelete}
                onDismiss={handleDialogCloseDelete}
                dialogContentProps={dialogContentPropsEdit}
                modalProps={modalPropsEdit}
                minWidth="560px"
            >
                <div>
                    <p>
                        You are about to delete the assessment with ID {props.id} for the selected POI. Are you sure you want to continue?
                    </p>
                </div>
                <DialogFooter>
                    <PrimaryButton onClick={() => handleDialogDelete(props.id)} text="Delete" />
                    <DefaultButton onClick={handleDialogCloseDelete} text="Cancel" />
                </DialogFooter>
            </Dialog>
        </div>

    );
}

export default DeleteDialog;